import React, { useEffect, useState } from "react";
import axios from "axios";
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import { Col, Row, Form, FloatingLabel, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import GLOBALVAR from "../constants";
import LoadingSpinner from "../components/misc/LoadingSpinner";
import { useNavigate } from 'react-router-dom';  

function ApplicationForm() {
    const [civilStatus, setCivilStatus] = useState("");
    const [isMarried, setIsMarried] = useState(false);
    const [birthday, setBirthday] = useState(null); // State to manage birthday
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState(null);
    const [modalBody, setModalBody] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [errMessages, setErrMessages] = useState(false);
    const navigate = useNavigate();

    const handleCivilStatusChange = (e) => {
        setCivilStatus(e.target.value);
        setIsMarried(e.target.value === "Married");
    };

    const handleBirthdayChange = (date) => {
        setBirthday(date);
        const formattedDate = format(date, 'MM/dd/yyyy'); 
        handleChange({ target: { name: "birthday", value: formattedDate } });
    };

    const [formData, setFormData] = useState({
        lastName: '',
        firstName: '',
        middleName: '',
        mothersMaidenName: '',
        street: '',
        barangay: '',
        municipality: '',
        province: '',
        zipCode: '',
        birthday: '',
        gender: '',
        civilStatus: '',
        marriedTo: '',
        telephoneNo: '',
        mobileNo1: '',
        mobileNo2: '',
        emailAddress: '',
        sssOrGsis: '',
        passport: '',
        employerDetails: '',
        employerAddress: '',
        employerContactNumber: '',
        employerLocation: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowSpinner(true);

        try {
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/applications/add`, formData);
            console.log(response.data.message); // Display the message returned from the server
            navigate('/dashboard');
        } catch (error) {
            console.error('Error submitting form:', error);
            setModalHeader('Validation Error');
            setModalBody('');

            const errorsArray = error.response.data.error.split(',\n');
            const filteredErrors = errorsArray.filter(error => error.trim() !== '');
            setErrMessages(filteredErrors);
            handleShow();
            setShowSpinner(false);
        }
    };

  useEffect(() => {
  
  }, []); 


  return (
    <>
      {showSpinner && (<LoadingSpinner />)}
      <NavMain slug="application-form" parent="1" />
      <HeaderMain slug="application-form" />
      <div className="main-content">
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{modalHeader}</Modal.Title>
          </Modal.Header>
          {errMessages && (
            <Modal.Body>
              <ul>
              {errMessages.map((error, index) => (
                <li key={index}>{error.trim().replace('Validation error: ', '')}</li>
              ))}
              </ul>
            </Modal.Body>
          )}
          {!errMessages && (
            <Modal.Body>
              {modalBody}
            </Modal.Body>
          )}
        </Modal>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingLastName" label="Last Name">
                <Form.Control type="text" name="lastName" placeholder="Last Name" onChange={handleChange} />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingFirstName" label="First Name">
                <Form.Control type="text" name="firstName" placeholder="First Name" onChange={handleChange} />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingMiddleName" label="Middle Name">
                <Form.Control type="text" name="middleName" placeholder="Middle Name" onChange={handleChange} />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingMothersMaidenName" label="Mother's Maiden Name">
                <Form.Control type="text" name="mothersMaidenName" placeholder="Mother's Maiden Name" onChange={handleChange} />
              </FloatingLabel>
            </Col>
          </Row>
          <hr className="my-4"></hr>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingStreet" label="House No. / Street">
                <Form.Control type="text" name="street" placeholder="House No. / Street" onChange={handleChange} />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingBarangay" label="Barangay">
                <Form.Control type="text" name="barangay" placeholder="Barangay" onChange={handleChange} />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingMunicipality" label="Municipality/City">
                <Form.Control type="text" name="municipality" placeholder="Municipality/City" onChange={handleChange} />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingProvince" label="Province">
                <Form.Control type="text" name="province" placeholder="Province" onChange={handleChange} />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingZipCode" label="Zip Code">
                <Form.Control type="text" name="zipCode" placeholder="Zip Code" onChange={handleChange} />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
            {birthday ? (
                <DatePicker
                className="form-control"
                selected={birthday} // Set the selected date
                onChange={(e) => {
                    handleBirthdayChange(e);
                }} // Handle date change
                dateFormat="MM/dd/yyyy" // Date format
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                maxDate={new Date()} // Max date is today
                name="birthday"
                />
              ) : (
                <FloatingLabel controlId="floatingBirthday" label="Birthday">
                  <DatePicker
                    className="form-control"
                    selected={birthday} // Set the selected date
                    onChange={(e) => {
                        handleBirthdayChange(e);
                    }} // Handle date change
                    dateFormat="MM/dd/yyyy" // Date format
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    maxDate={new Date()} // Max date is today
                    name="birthday"
                    />
                </FloatingLabel>
              )}
            </Col>
            <Col>
              <FloatingLabel controlId="floatingGender" label="Gender">
                <Form.Select defaultValue="Select Gender" name="gender" onChange={handleChange}>
                  <option>Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingCivilStatus" label="Civil Status">
                <Form.Select value={civilStatus} name="civilStatus" onChange={(e)=>{handleCivilStatusChange(e);handleChange(e);}}>
                  <option>Select Civil Status</option>
                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Widow">Widow</option>
                  <option value="Separated">Separated</option>
                  <option value="Annulled">Annulled</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
          </Row>
          {isMarried && (
            <Row className="mb-3">
              <Col>
                <FloatingLabel controlId="floatingMarriedTo" label="Married To">
                  <Form.Control type="text" placeholder="Married To" onChange={handleChange} name="marriedTo" />
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel controlId="floatingTelephoneNo" label="Telephone No.">
                  <Form.Control type="text" placeholder="Telephone No." onChange={handleChange} name="telephoneNo" />
                </FloatingLabel>
              </Col>
            </Row>
          )}
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingMobileNo1" label="Mobile No. 1">
                <Form.Control type="text" placeholder="Mobile No. 1" onChange={handleChange} name="mobileNo1"/>
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingMobileNo2" label="Mobile No. 2">
                <Form.Control type="text" placeholder="Mobile No. 2" onChange={handleChange} name="mobileNo2" />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingEmailAddress" label="E-Mail Address">
                <Form.Control type="email" placeholder="E-Mail Address" onChange={handleChange} name="emailAddress" />
              </FloatingLabel>
            </Col>
          </Row>
          <hr className="my-4"></hr>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingSSSOrGSIS" label="SSS/GSIS #">
                <Form.Control type="text" placeholder="SSS/GSIS #" onChange={handleChange} name="sssOrGsis" />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingPassport" label="Passport #">
                <Form.Control type="text" placeholder="Passport #" onChange={handleChange} name="passport" />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingEmployerDetails" label="Employer Details">
                <Form.Control type="text" placeholder="Employer Details" onChange={handleChange} name="employerDetails" />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingEmployerAddress" label="Employer Address">
                <Form.Control type="text" placeholder="Employer Address" onChange={handleChange} name="employerAddress" />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <FloatingLabel controlId="floatingEmployerContactNumber" label="Employer Contact Number">
                <Form.Control type="text" placeholder="Employer Contact Number" onChange={handleChange} name="employerContactNumber" />
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="floatingEmployerLocation" label="Employer Location">
                <Form.Control type="text" placeholder="Employer Location" onChange={handleChange} name="employerLocation" />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
                <Button variant="primary" type="submit" className="submit-btn" id="submit-application">Submit Application</Button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
}

export default ApplicationForm;
